import React, { useEffect, useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { Link } from 'react-router-dom';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { FaEdit, FaSearch, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';

const Listsyallbus = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [list, setList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  // Initial fetch on mount
  useEffect(() => {
    callAPI("get", "admin/robotic-syllabuses", "");
  }, []);

  // Populate the list when response arrives
  useEffect(() => {
    if (response?.data && statusCode === 200) {
      setList(response.data);
      setIsDelete(false);
    }
  }, [response, statusCode]);

  const deleteRecord = (id) => {
    if (window.confirm("Are you sure you want to delete this syllabus?")) {
      callAPI("delete", `admin/robotic-syllabuses/${id}`, "");
      setIsDelete(true);
    }
  };

  // Show toast once deletion completes
  useEffect(() => {
    if (statusCode === 204 && isDelete) {
      toast.success("Robotic Syllabus deleted successfully!");
      callAPI("get", "admin/robotic-syllabuses", "");
    }
  }, [statusCode, isDelete]);

  const filteredList = list.filter(item =>
    (item.class || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.age || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.level || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Robotic Syllabus List"
                subTitle="Manage Robotic Syllabus"
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to="/robotic-syallbus/add">
                <button className="btn btn-primary">Add Syllabus</button>
              </Link>
            </div>
          </div>

          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <h5 className="mb-0 fw-semibold">Syllabus List</h5>
                </div>
                <div className="col-12 col-md-9 d-flex justify-content-end">
                  <div className="input-group w-100 w-md-auto">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by class, age, or level"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">#</th>
                    <th className="px-4 py-2">Class</th>
                    <th className="px-4 py-2">Age</th>
                    <th className="px-4 py-2">Price</th>
                    <th className="px-4 py-2">Level</th>
                    <th className="px-4 py-2">Practical</th>
                    <th className="px-4 py-2">Theory</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((li, index) => (
                    <tr key={li.id} className="sys-list-table__row border-bottom">
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2">{li.class}</td>
                      <td className="px-4 py-2">{li.age}</td>
                      <td className="px-4 py-2">{li.price}</td>
                      <td className="px-4 py-2">{li.level}</td>
                      <td className="px-4 py-2">{li.practical}</td>
                      <td className="px-4 py-2">{li.theory}</td>
                      <td className="px-4 py-2 text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link
                            to={uiRoutes.admin.roboticSyllabus.edit.replace(
                              ":id",
                              li.id
                            )}
                          >
                            <button
                              className="sys-list-table__action edit"
                              title="Edit"
                            >
                              <FaEdit />
                            </button>
                          </Link>
                          <button
                            className="sys-list-table__action delete"
                            title="Delete"
                            onClick={() => deleteRecord(li.id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {filteredList.length === 0 && (
                    <tr>
                      <td colSpan={8} className="text-center py-4 text-muted">
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default Listsyallbus;
